// ─── Version de l'application ─────────────────────────────────────────────────
// Incrémente APP_VERSION à chaque déploiement// Version force le rafraîchissement du Service Worker en production
// Doit correspondre ou être supérieur au package.json
export const APP_VERSION = '4.3.2';